import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import * as React from "react";
import { addDisplayName } from "../Infra/display-name";
import { useViewModel } from "./useViewModel";
import { AcceptInviteViewModel } from "./AcceptInviteViewModel";
export const AcceptInviteView = observer((props) => {
    useViewModel(AcceptInviteViewModel, props.container);
    return _jsx(_Fragment, {});
});
addDisplayName(AcceptInviteView, "AcceptInviteView");
